import { ApiService } from "../api.services";

const ledgerService = {
  //Create Ledger
  CreateLedger: ({ name, category, type, description, parent }) => {
    return new Promise(function(resolve, reject) {
      ApiService.post("/ledgers/create", {
        name,
        category,
        type,
        description,
        parent
      })
        .then(({ data }) => {
          resolve(data);
          //ApiService.setHeader(data.token);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

  //Get All Ledgers
  GetLedgers: async () => {
    return await ApiService.get("/ledgers")
      .then(res => {
        return Promise.resolve(res.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data);
      });
  }
};

export { ledgerService };
